<template>
  <div class="login-wide" :class="{show:show}" @click.stop="bgClickHandle"
    :style="{opacity:`${hidden?0:1}`}" 
    @touchmove.stop="" @touchstart.stop="">
    <div class="login-w-border" :style="{width:width}"
      :class="{show:borderShow,'v-rotate':isVictRotate}" @click.stop="">
      <img @click="closeClick" class="l-t-close" 
        src="../../assets/login/login-close.png" />
      <div class="login-w-i">
        <div class="login-t-bar">
          <slot name="title">
          </slot>
        </div>
        <div class="login-c-w">
          <div class="o-background">
            <div class="i-background" :class="{full:isFull}">
              <slot name="content">
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Tool from '../../common/Tool.js'
export default {
  props:{
    bgClickClose:Number,
    isShow:Number,
    isFull:{
      type:Number,
      require:false
    },
    width:{
      type:String,
      require:false
    }
  },
  data(){
    return{
      show:0,
      borderShow:0,
      hidden:0,
      isVictRotate:0,
    }
  },
  mounted(){
    this.horizontalVerctCheck();
  },
  methods:{
    horizontalVerctCheck(){
      let frame = () => {
        let noNeedShuping = Tool.noNeedShupingRotate();
        if(location.href.indexOf('/customer') > -1){
          noNeedShuping = false;
        }
        let gameRotate = localStorage.getItem('game-is-shuping');
        if(gameRotate){
          gameRotate =  1 * gameRotate;
        }else{
          gameRotate =  0;
        }

        if(innerHeight > innerWidth && noNeedShuping && !gameRotate){
          this.isVictRotate = 1;
        }else{
          this.isVictRotate = 0;
        }
      }
      frame();
      window.addEventListener('orientationchange',frame);
      window.addEventListener('resize',frame);
    },
    bgClickHandle(){
      if(this.bgClickClose){
        this.closeClick();
      }
    },
    closeClick(){
      this.hidden = 1;
      this.$emit('hideClosed')
      setTimeout(() => {
        this.borderShow = 0
        this.show = 0
        this.$emit('closed')
      },600)
    }
  },
  watch:{
    isShow(n,o){
      const _this = this;
      this.hidden = 0;
      if(n){
        this.show = n;
        setTimeout(() => {
          _this.borderShow = n
        })
      }else{
        this.closeClick();
      }
      
    }
  }
}
</script>
<style scoped lang="stylus">
.login-wide
  width 100%
  height 100%
  position fixed
  background-color rgba(0,0,0,.6)
  z-index 3
  top 0
  left 0
  display none
  &.show
    display flex
  .login-w-border
    width 4.9rem
    height auto
    margin auto
    padding .01rem 0
    display flex
    position relative
    .l-t-close
      width .3rem
      height .3rem
      right -.12rem
      top -.06rem
      position absolute
      z-index 1
    &.v-rotate
      transform rotateZ(90deg)
    .login-w-i
      width 100%
      border-radius .2rem
      overflow hidden
      height auto
      margin auto
      background-image url('../../assets/login/sign-bg.png')
      background-size 100% 100%
      
      .login-t-bar
        width 100%
        height .4rem
        margin auto
        position relative
        &/deep/ .l-t-title
          height 100%
      .login-c-w
        width 100%
        margin .01rem auto 0 auto
        position relative
        .o-background
          padding .1rem
          .i-background
            padding-bottom .1rem
            text-align center
            &.full
              padding-bottom 0
        .l-c-bg1
          width 100%
          height 2.14rem
          display block
        .l-c-bg
          width 4.66rem
          height 1.94rem
          display block
          position absolute
          top 50%
          left 50%
          transform translateX(-50%) translateY(-50%)
        .l-c-w-i
          width 100%
          border-top 1px solid transparent
          padding-top .2rem
          .l-c-w-ir
            width 100%
            display flex
            margin-top .18rem
            justify-content center
            align-items center
            color #8D6935
            &.reg
              font-size .12rem
              margin-top .1rem
              font-weight bold
              justify-content flex-end
              & > div
                margin-right .18rem
                &.forget-link
                  margin-right .4rem
            .confirm-btn
              width 1.12rem
            input
              background-color #BEA37B
              border none
              border-radius .12rem
              width 2rem
              height .25rem
              color #fff
              padding-left .05rem
</style>